
// 目次生成
// ・記事本文内の[目次]箇所を目次に自動差し替え


  document.addEventListener("DOMContentLoaded", function () {
      
      const articleDiv = document.querySelector(".article__body");
      const articleContent = articleDiv.innerHTML;      
      if (articleContent.includes("[目次]")) {
        const replacedContent = articleContent.replace("[目次]", '<div id="toc"></div>');        
        articleDiv.innerHTML = replacedContent;
        
          // 設定
          const TOC_INSERT_SELECTOR = '#toc';
          const HEADING_SELECTOR    = '.article__body h2';
          const LINK_CLASS_NAME     = 'tocLink link--faded';
          const ID_NAME             = 'heading';
          const tocInsertElement    = document.querySelector(TOC_INSERT_SELECTOR);
          const headingElements     = document.querySelectorAll(HEADING_SELECTOR);
          const layer = [];
          let id = 0;
          const uid   = () =>`${ID_NAME}${id++}`;
          let oldRank = -1;
          try {
              const createLink = (el) => {
                  let li = document.createElement('li');
                  let a  = document.createElement('a');
                  el.id  = el.id || uid();
                  a.href = `#${el.id}`;
                  a.innerText = el.innerText;
                  a.className = LINK_CLASS_NAME;
                  li.appendChild(a);
                  return li;
              };
              const findParentElement = (layer, rank, diff) => {
                  do {
                      rank += diff;
                      if (layer[rank]) return layer[rank];
                  } while (0 < rank && rank < 7);
                  return false;
              };
              const appendToc = (el, toc) => {
                  el.appendChild(toc.cloneNode(true));
              };
              headingElements.forEach( (el) => {
                  let rank   = Number(el.tagName.substring(1));
                  let parent = findParentElement(layer, rank, -1);
                  if (oldRank > rank) layer.length = rank + 1;
                  if (!layer[rank]) {
                      layer[rank] = document.createElement('ul');
                      if (parent.lastChild) parent.lastChild.appendChild(layer[rank]);
                  }
                  layer[rank].appendChild(createLink(el));
                  oldRank = rank;
              });
              if (layer.length) appendToc(tocInsertElement, findParentElement(layer, 0, 1));        
      
            
              if( layer.length == 0 ){
                document.getElementById("toc").style.display = "none"; 
              }
          } catch (e) {
              //error 
          }

      }
    });


// ulやolがあったら、<div class="article_list">でラップする

document.querySelectorAll('.c_article__body ul, .c_article__body ol').forEach(list => {
  const parent = list.parentElement;

  // すでに .article_list でラップされていない場合のみ実行
  if (!parent.classList.contains('c_article_list')) {
    const wrapper = document.createElement('div');
    wrapper.className = 'c_article_list';

    // listの前に wrapper を挿入して、list を wrapper に移動
    parent.insertBefore(wrapper, list);
    wrapper.appendChild(list);
  }
});

// スムーススクロール＋ヘッダー分ずらす

document.addEventListener('DOMContentLoaded', () => {
    const headerHeight = 200; // ← 固定ヘッダーの高さ（px）
  
    // 🔹 ページ内リンククリック時の処理
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href').slice(1);
        const targetElement = document.getElementById(targetId);
  
        if (targetElement) {
          e.preventDefault();
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
  
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
  
          // URLのハッシュもちゃんと更新
          history.pushState(null, null, `#${targetId}`);
        }
      });
    });
  
    // 🔹 ページ読み込み時のハッシュ対応（スクロール位置調整）
    if (window.location.hash) {
      const targetId = window.location.hash.slice(1);
      const targetElement = document.getElementById(targetId);
  
      if (targetElement) {
        // 遅延して実行（レイアウトが安定してから）
        setTimeout(() => {
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
  
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth' // 読み込み時は即移動（滑らかにしたいなら 'smooth' に）
          });
        }, 100); // レイアウトが安定する時間を見て調整（必要に応じて変更可）
      }
    }
  });
  
///* product-block */

// 目次生成
// ・記事本文内の[目次]箇所を目次に自動差し替え


document.addEventListener("DOMContentLoaded", function () {
      
  const articleDiv = document.querySelector(".c_product-block");
  const articleContent = articleDiv.innerHTML;
  if (articleContent.includes("[目次]")) {
    const replacedContent = articleContent.replace("[目次]", '<div id="toc"></div>');        
    articleDiv.innerHTML = replacedContent;
    
      // 設定
      const TOC_INSERT_SELECTOR = '#toc';
      const HEADING_SELECTOR    = '.c_product-block h2';
      const LINK_CLASS_NAME     = 'tocLink link--faded';
      const ID_NAME             = 'heading';
      const tocInsertElement    = document.querySelector(TOC_INSERT_SELECTOR);
      const headingElements     = document.querySelectorAll(HEADING_SELECTOR);
      const layer = [];
      let id = 0;
      const uid   = () =>`${ID_NAME}${id++}`;
      let oldRank = -1;
      try {
          const createLink = (el) => {
              let li = document.createElement('li');
              let a  = document.createElement('a');
              el.id  = el.id || uid();
              a.href = `#${el.id}`;
              a.innerText = el.innerText;
              a.className = LINK_CLASS_NAME;
              li.appendChild(a);
              return li;
          };
          const findParentElement = (layer, rank, diff) => {
              do {
                  rank += diff;
                  if (layer[rank]) return layer[rank];
              } while (0 < rank && rank < 7);
              return false;
          };
          const appendToc = (el, toc) => {
              el.appendChild(toc.cloneNode(true));
          };
          headingElements.forEach( (el) => {
              let rank   = Number(el.tagName.substring(1));
              let parent = findParentElement(layer, rank, -1);
              if (oldRank > rank) layer.length = rank + 1;
              if (!layer[rank]) {
                  layer[rank] = document.createElement('ul');
                  if (parent.lastChild) parent.lastChild.appendChild(layer[rank]);
              }
              layer[rank].appendChild(createLink(el));
              oldRank = rank;
          });
          if (layer.length) appendToc(tocInsertElement, findParentElement(layer, 0, 1));        
  
        
          if( layer.length == 0 ){
            document.getElementById("toc").style.display = "none"; 
          }
      } catch (e) {
          //error 
      }

  }
});


// ulやolがあったら、<div class="article_list">でラップする

document.querySelectorAll('.c_product-block ul, .c_product-block ol').forEach(list => {
const parent = list.parentElement;

// すでに .article_list でラップされていない場合のみ実行
if (!parent.classList.contains('c_article_list')) {
const wrapper = document.createElement('div');
wrapper.className = 'c_article_list';

// listの前に wrapper を挿入して、list を wrapper に移動
parent.insertBefore(wrapper, list);
wrapper.appendChild(list);
}
});